import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "选择投标报价", -1)
const _hoisted_2 = {
  key: 0,
  class: "text-grey ml10"
}

export function render(_ctx, _cache) {
  const _component_a_input_search = _resolveComponent("a-input-search")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
    }, "从投标报价导入"),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = $event => ((_ctx.visible) = $event)),
      width: "1000px",
      keyboard: false,
      centered: true,
      "mask-closable": false,
      onOk: _ctx.ok,
      onCancel: _ctx.closeModal
    }, {
      title: _withCtx(() => [
        _hoisted_1,
        (_ctx.needProjectId)
          ? (_openBlock(), _createElementBlock("small", _hoisted_2, "仅展示已选项目下的投标报价"))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "inline" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_search, {
                  value: _ctx.queryRef.bidOfferBizNo,
                  "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.queryRef.bidOfferBizNo) = $event)),
                  valueModifiers: { trim: true },
                  placeholder: "请输入投标报价编号",
                  style: {"width":"250px"},
                  "enter-button": "",
                  "allow-clear": "",
                  loading: _ctx.loading,
                  onSearch: _ctx.search
                }, null, 8, ["value", "loading", "onSearch"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_table, {
          size: "small",
          "row-key": "id",
          class: "mt15",
          bordered: true,
          loading: _ctx.loading,
          "data-source": _ctx.dataSource,
          pagination: _ctx.pagination,
          columns: _ctx.columns,
          scroll: { x: 1100 },
          "row-selection": {
      selectedRowKeys: _ctx.selectedKeys,
      onChange: _ctx.onSelectionChange,
      fixed: true,
      type: 'radio'
    },
          onChange: _ctx.onTableChange
        }, null, 8, ["loading", "data-source", "pagination", "columns", "row-selection", "onChange"])
      ]),
      _: 1
    }, 8, ["visible", "onOk", "onCancel"])
  ], 64))
}